module.exports = __webpack_public_path__ + "media/normalvideo.11ba4447.mp4";